import styled from "styled-components";

export const AboutPageWrapper = styled.div`
  padding-bottom: 25px;
`;
